var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.864 12.8476L17.3904 16.4159L16.2254 17.5951L12.6998 14.0259C11.3879 15.0903 9.75626 15.6692 8.07498 15.6667C3.98456 15.6667 0.664795 12.3067 0.664795 8.16675C0.664795 4.02675 3.98456 0.666748 8.07498 0.666748C12.1654 0.666748 15.4852 4.02675 15.4852 8.16675C15.4875 9.86842 14.9156 11.5199 13.864 12.8476ZM12.2123 12.2292C13.2573 11.1417 13.8408 9.68377 13.8384 8.16675C13.8384 4.94341 11.2589 2.33341 8.07498 2.33341C4.89024 2.33341 2.3115 4.94341 2.3115 8.16675C2.3115 11.3892 4.89024 14.0001 8.07498 14.0001C9.57383 14.0025 11.0143 13.4118 12.0888 12.3542L12.2123 12.2292Z",
    fill: "#2E2E2E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f2788a7522ea2aa283b5b817374c2091.svg";
export { ForwardRef as ReactComponent };